import type { RootState } from "../state";

// 此文件包含音频激活器相关的逻辑

export function startAutoplayActivator(
  this: RootState & { [key: string]: any }
) {
  if (this.isAutoplayActivatorRunning) {
    // 🚀 如果已经在运行，立即处理一次队列（权限获取成功后的快速响应）
    this.processActivationQueue();
    return;
  }

  this.isAutoplayActivatorRunning = true;

  // 🚀 立即处理一次队列，不要等待定时器
  this.processActivationQueue();

  const _activatorInterval = setInterval(() => {
    this.processActivationQueue();
  }, 100); // 🚀 将间隔从200ms减少到100ms，提高响应速度
}

// 🚀 处理激活队列的核心方法
export function processActivationQueue(
  this: RootState & { [key: string]: any }
) {
  if (this.pendingActivationQueue.length === 0) {
    return;
  }

  // 从队列中取出一个房间进行激活
  const roomIdToActivate = this.pendingActivationQueue.shift();
  if (!roomIdToActivate) return;

  const state = this.roomStates.get(roomIdToActivate);
  if (
    state &&
    (state as any).howlerPlayer &&
    !(state as any).howlerPlayer.getStatus().isPlaying
  ) {
    const howlerPlayer = (state as any).howlerPlayer;

    // 关键：这里的调用栈非常干净
    const playPromise = howlerPlayer.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          this.updateMediaEngagement(); // 累积MEI分数
          state.isPlaying = true;

          // 恢复正确的音量/静音状态
          const isCurrentRoom = this.currentRoomId === roomIdToActivate;
          // 🔇 检查是否在直播间详情页（有currentRoomState）
          const isInLiveRoomDetail = !!this.currentRoomState;

          if (isCurrentRoom && isInLiveRoomDetail) {
            howlerPlayer.setMuted(false);
            howlerPlayer.setVolume(1.0);
            console.log(`🔊 激活器：房间 ${roomIdToActivate} 当前房间有声播放`);
          } else {
            howlerPlayer.setMuted(true);
            howlerPlayer.setVolume(0);
            console.log(`🔇 激活器：房间 ${roomIdToActivate} 后台静音播放`);
          }
        })
        .catch(error => {
          console.warn(
            `🔇 激活器播放失败 (${error.name})，房间 ${roomIdToActivate} 需要真实用户交互`
          );
          // 旧播放器属性已移除，使用 Howler.js 统一管理
          state.isPlaying = false;

          // 🚀 只有在真正需要播放但没有权限时才请求用户授权
          if (localStorage.getItem("userHasGrantedPermissionEver") !== "true") {
            console.log("🔇 检测到播放失败且无永久授权，现在请求用户授权...");
            this.requestUserActivation();
          }
        });
    }
  }
}

// 媒体参与度更新
export function updateMediaEngagement(
  this: RootState & { [key: string]: any }
) {
  // 简化的MEI分数更新逻辑
  console.log("📈 更新媒体参与度分数");
}

// 请求用户激活
export function requestUserActivation(
  this: RootState & { [key: string]: any }
) {
  console.log("🙋‍♀️ 请求用户激活音频权限");
  // 显示用户交互提示等逻辑
}
